module.exports = __webpack_public_path__ + "static/favicon-693897d502a91e5de746cbaf84f107c1.png";